import { ProviderAuthenticationCommon } from '~/plugins/data-connector/authentication/common'

export const ProviderSlackCommon = {
  key: 'slack',
  authentication: ProviderAuthenticationCommon.Oauth2({
    key: 'slack',
    authUrl: 'https://slack.com/oauth/v2/authorize',
    tokenUrl: 'https://slack.com/api/oauth.v2.access',
    scopes: ['channels:read', 'chat:write', 'users:read', 'users.profile:read'],
  }),
}

export type ProviderSlackAccountType = null
export type ProviderSlackConnectionType = {
  ok: boolean
  app_id: string
  authed_user: { id: string }
  scope: string
  token_type: string
  access_token: string
  bot_user_id: string
  team: { id: string; name: string }
  enterprise: any
  is_enterprise_install: boolean
}
